const getTextWidth = (text, font) => {
  var canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement("canvas"));
  var context = canvas.getContext("2d");
  context.font = font;
  var metrics = context.measureText(text);
  return metrics.width;
};

const addExitVrHotspot = (label) => {
  // Create exit vr hotspot
  let spotName = `vr_exit`;
  let spot = krpanoObj.addhotspot(spotName);
  spot.loadstyle("vr_hotspot_style");
  spot.text = label;
  spot.textwidth = getTextWidth(spot.text, "bold 16px arial") + 72;
  spot.ath = 0;
  spot.atv = 90;
  spot.actiontype = "exit_vr";
};

const addSingleVrHotspot = (hotspot, label) => {
  // Create vr hotspot
  hotspot.classList.add("invisible");
  if (hotspot.nextElementSibling) {
    hotspot.nextElementSibling.classList.add("invisible");
  }
  let spotName = `vr_${hotspot.dataset.slug}`;
  let spot = krpanoObj.get(`hotspot["${spotName}"]`);

  if (hotspot.dataset.type == "navigation" && !spot) {
    spot = krpanoObj.addhotspot(spotName);
    spot.loadstyle("vr_hotspot_style");
    spot.text = hotspot.dataset.title ? hotspot.dataset.title : label;
    spot.textwidth =
      getTextWidth(spot.text, "bold 16px arial") + 72;
    spot.ath = hotspot.dataset.ath;
    spot.atv = hotspot.dataset.atv;
    spot.actiontype = "navigation";
    spot.actionslug = hotspot.dataset.slug;
    spot.actionname = hotspot.dataset.name;
  }
};

const addVrHotspots = (label) => {
  // Copy original hotspots
  addExitVrHotspot(label.exit);
  let hotspots = document.querySelectorAll(".hotspot");
  hotspots.forEach((hotspot) => {
    addSingleVrHotspot(hotspot, label.continue);
  });
};

const removeVrHotspots = () => {
  let hotspots = document.querySelectorAll(".hotspot");
  hotspots.forEach((hotspot) => {
    let spotName = `vr_${hotspot.dataset.slug}`;
    krpanoObj.removehotspot(spotName);
    krpanoObj.removehotspot(`vr_${hotspot.dataset.slug}_text`);
    krpanoObj.removehotspot(`vr_${hotspot.dataset.slug}_hitarea`);
    krpanoObj.removehotspot(`vr_${hotspot.dataset.slug}_hover`);
    hotspot.classList.remove("invisible");
    if (hotspot.nextElementSibling) {
      hotspot.nextElementSibling.classList.remove("invisible");
    }
  });

  // remove exit vr hotspot
  let spot = krpanoObj.removehotspot("vr_exit");
  krpanoObj.removehotspot(`vr_exit_text`);
  krpanoObj.removehotspot(`vr_exit_hitarea`);
  krpanoObj.removehotspot(`vr_exit_hover`);
};

export {
  addExitVrHotspot,
  addSingleVrHotspot,
  addVrHotspots,
  removeVrHotspots,
};
